<p-toast></p-toast>
<p-confirmDialog [style]="{minWidth: '40vw'}" position="top" [baseZIndex]="10000" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<div class="grid">
    <div class="col-12">
        <div class="card">
			<h5>Estados de cuenta</h5>
            <hr>
            <form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="ejecutar()">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12">
                        <label for="usuarios">Agrupaciones:</label>
                        <p-multiSelect
                            [options]="agrupaciones"
                            optionLabel="des_agrupacion"
                            optionValue="cod_agrupacion"
                            display="des_agrupacion"
                            formControlName="agrupaciones"
                            placeholder="Seleccione las agrupaciones"
                            [showToggleAll]="true"
                            display="chip"
                        ></p-multiSelect>
                    </div>
                </div>
                <div class="grid">
                    <div class="col-12 md:col-2">
                        <button pButton pRipple type="submit" label="Ejecutar" icon="pi pi-check" class="p-button-info mr-2" pTooltip="Ejecutar"></button>
                    </div>
                    <ng-container *ngIf="items?.length">
                        <div class="col-12 md:col-2">
                            <button pButton pRipple class="p-button-warning" label="Imprimir" icon="pi pi-print" (click)="descargar()"></button>
                        </div>
                        <div class="col-12 md:col-2">
                            <button pButton pRipple class="p-button-success" label="Descargar" icon="pi pi-file-excel" (click)="descargarExcel()"></button>
                        </div>
                    </ng-container>
                </div>
            </form>
            <p-table styleClass="p-datatable-sm p-datatable-gridlines" [value]="items" [loading]="loading" dataKey="id" responsiveLayout="scroll" rowHover="true"
            [showCurrentPageReport]="true" [paginator]="true" [rows]="20" currentPageReportTemplate="Mostrando {first} a {last} de {{items.length}} entradas">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="cabecera-detalle align-center" pSortableColumn="cod_agrupacion">Cod. de agrupacion<p-sortIcon field="cod_agrupacion"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="des_agrupacion">Agrupacion<p-sortIcon field="des_agrupacion"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="limite_credito">Limite de credito<p-sortIcon field="limite_credito"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="saldo_capital">Saldo capital<p-sortIcon field="saldo_capital"></p-sortIcon></th>
                        <th class="cabecera-detalle align-center" pSortableColumn="saldo_limite">Saldo Limite<p-sortIcon field="saldo_limite"></p-sortIcon></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item >
                    <tr class="p-0 m-0">
                        <td class="align-center">{{ item.cod_agrupacion }}</td>
                        <td class="align-start">{{ item.des_agrupacion }}</td>
                        <td class="align-end">{{ ( item.limite_credito   || 0 | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}</td>
                        <td class="align-end">{{ ( item.saldo_capital   || 0 | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}</td>
                        <td class="align-end">{{ ( item.saldo_limite   || 0 | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}</td>
                        <!-- <td class="align-center">{{ item.fecha_gestion | date: 'dd/MM/yyyy' }}</td> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                    <tr>
                        <td class="cabecera-detalle" colspan="2">TOTALES</td>
                        <td class="cabecera-detalle align-end"><b>{{ ( totalLimiteCredito || 0 | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}</b></td>
                        <td class="cabecera-detalle align-end"><b>{{ ( totalSaldoCapital || 0 | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}</b></td>
                        <td class="cabecera-detalle align-end"><b>{{ ( totalSaldoLimite || 0 | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}</b></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<app-on-lista [show]="showOnLista" [title]="tituloOnLista" [columns]="columnasOnLista" [service]="serviceOnLista" [recordName]="recordNameOnLista" [filters]="filters"
(close)="cerrarOnLista($event)">
</app-on-lista>

